import { axios } from '@/utils/request'
const api = {
  source: '/order/AccessoryOrder',
}
// /feedback/transfer 1.3.8问题反馈转派
export function gettransfer (parameter) {
  return axios({
    url: `/backlog/feedback/transfer?feedbackHeaderId=` + parameter.feedbackHeaderId + '&roleCode=' + parameter.roleCode,
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 1.3.9问题反馈开始处理
export function getstartProcessing(parameter) {
  return axios({
    url: 'backlog/feedback/startProcessing',
    method: 'post',
    params: parameter,
    // data: parameter,
    // headers: {
    //   'Content-Type': 'application/json;charset=UTF-8'
    // }
  })
}
// 1.3.9问题反馈开始处理
export function getendProcessing(parameter) {
  return axios({
    url: 'backlog/feedback/end',
    method: 'post',
    params: parameter,
    // data: parameter,
    // headers: {
    //   'Content-Type': 'application/json;charset=UTF-8'
    // }
  })
}
// 1.3.11问题反馈处理完成
export function getprocessingCompleted(parameter) {
  return axios({
    url: 'backlog/feedback/processingCompleted',
    method: 'post',
    params: parameter,
    // data: parameter,
    // headers: {
    //   'Content-Type': 'application/json;charset=UTF-8'
    // }
  })
}
// 1.2.12申诉
export function getappeal(parameter) {
  return axios({
    url: 'backlog/feedback/appeal',
    method: 'post',
    // params: parameter,
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 1.3.10问题反馈回复
export function getreply(parameter) {
  return axios({
    url: 'backlog/feedback/reply',
    method: 'post',
    // params: parameter,
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 修改待办事项
export function getupdateFeedback(parameter) {
  return axios({
    url: 'backlog/feedback/updateFeedback',
    method: 'post',
    // params: parameter,
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 撤回事项
export function getrevokeFeedback(parameter) {
  return axios({
    url: 'backlog/feedback/revoke',
    method: 'post',
    params: parameter,
    // data: parameter,
    // headers: {
    //   'Content-Type': 'application/json;charset=UTF-8'
    // }
  })
}
export function getfeedbacklist (parameter) {
  return axios({
    url:  '/order/feedback/get',
    method: 'get',
    params: parameter,
  })
}
// /feedback/getFeedbackInfo
export function getPendingMattersResume (parameter) {
  return axios({
    url:  '/backlog/pendingMatter/getPendingMattersResume',
    method: 'get',
    params: parameter,
  })
}
// 1.1.4获取待办事项角色列表
export function getPendingMattersRoleList (parameter) {
  return axios({
    url: '/backlog/pendingMatter/getPendingMattersRoleList',
    method: 'get',
    params: parameter,
  })
}
// 获取投诉详情
export function getFeedbackInfo (parameter) {
  return axios({
    url:  '/backlog/feedback/getFeedbackInfo',
    method: 'get',
    params: parameter,
  })
}

export function getPendingMatterMenu (parameter) {
  return axios({
    url:  '/backlog/pendingMatter/getPendingMatterMenu',
    method: 'get',
    params: parameter,
  })
}

export function exportFeedbackOrder (parameter) {
  return axios({
    url: 'order/feedback/exportFeedbackOrder',
    method: 'get',
    params: parameter,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }
  })

}